import { Features } from 'generated/featureDefinitions'
import { NewExpensesPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { useExpensesNavigation } from './useExpensesNavigation'

const useNewExpensesPage = () => {
  const expensesNavigation = useExpensesNavigation()
  const { company } = useCurrentSession()
  const companyId = company?.id
  const { data, loading: loadingPageData } = useQuery(NewExpensesPageDocument, {
    variables: {
      companyId,
      ids: [
        Features.projects_management,
        Features.projects_with_subprojects,
        Features.expenses_report_on_behalf,
        Features.expenses_spending_policies,
      ],
    },
  })

  const customizationFields = data?.expenses?.customizationFields ?? []
  const featureAvailability = data?.companies.featureAvailabilities
  const canCreateExpensesForOthers =
    data?.expenses._policies.expenseCreateExpensesForOthers.can ?? false

  const hasProjectsFeature =
    featureAvailability?.find((feature) => feature.id === Features.projects_management)
      ?.available ?? false

  const hasSubprojectsFeature =
    featureAvailability?.find((feature) => feature.id === Features.projects_with_subprojects)
      ?.available ?? false

  const hasReportOnBehalfFeature =
    featureAvailability?.find((feature) => feature.id === Features.expenses_report_on_behalf)
      ?.available ?? false

  const canUseSpendingPolicies =
    featureAvailability?.find((f) => f.id === Features.expenses_spending_policies)?.available ??
    false

  const hasCostCentersFeature =
    data?.features?.featuresConnection?.nodes.find(
      (feature) => feature.name === 'dev_cost_centers_v2'
    )?.enabled ?? false

  const isNewPerDiemWizardEnabled =
    data?.features?.featuresConnection?.nodes.find(
      (feature) => feature.name === 'dev_expenses_germany_per_diem'
    )?.enabled ?? false

  return {
    loading: loadingPageData,
    customizationFields,
    hasProjectsFeature: hasProjectsFeature && hasSubprojectsFeature,
    hasCostCentersFeature,
    hasReportOnBehalfFeature,
    canCreateExpensesForOthers,
    canUseSpendingPolicies,
    isNewPerDiemWizardEnabled,
    canOverrideApprovalFlow: data?.expenses._policies.expenseOverrideApprovalFlow.can ?? false,
    canCustomizeSettings: data?.expenses._policies.expenseCustomizeSettings.can ?? false,
    canSeeEmployeeLegalEntity: data?.expenses._policies.expenseSeeEmployeeLegalEntity.can ?? false,
    ...expensesNavigation,
  }
}

export default useNewExpensesPage
